import React from "react";
import { NavLink } from "react-router-dom";
import { AiOutlineFacebook, AiOutlineMail } from "react-icons/ai";
import { CiInstagram } from "react-icons/ci";
import { FaSquareTwitter } from "react-icons/fa6";
import { TfiYoutube } from "react-icons/tfi";
import { MdOutlineLocalPhone } from "react-icons/md";
function Footer() {
  return (
    <footer className="flex flex-col bg-brand-footer-bg p-6 text-brand-light-gray">
      {/* Logo and Links Section */}
      <div className="mb-4 flex flex-col items-center md:flex-row">
        <img
          src="\images\logo\footer_logo.png"
          alt="Bricks and Mix Logo"
          className="mb-2 h-10 w-auto"
        />
        <p className="m-auto text-center text-xs text-brand-text-light">
          <NavLink
            to="/about"
            className="hover:underline"
            aria-label="About bricksnmix.com"
          >
            About bricksnmix.com
          </NavLink>{" "}
          |{" "}
          <NavLink
            // to="/warranty"
            className="hover:underline"
            aria-label="Warranty policy"
          >
            Warranty policy
          </NavLink>{" "}
          |{" "}
          <NavLink
            to="/privacy-policy"
            className="hover:underline"
            aria-label="Privacy policy"
          >
            Privacy policy
          </NavLink>{" "}
          |{" "}
          <NavLink
            to="/terms-and-conditions"
            className="hover:underline"
            aria-label="Terms and Conditions"
          >
            Terms and Conditions
          </NavLink>{" "}
          |{" "}
          <NavLink
            to="/contact-us"
            className="hover:underline"
            aria-label="Contact us"
          >
            Contact us
          </NavLink>
        </p>
      </div>

      {/* Information Section */}
      <div className="mb-4 flex flex-col gap-x-5 text-sm md:flex-row md:justify-between">
        <div className="mb-4 md:mb-0 md:w-1/2">
          <h2 className="text-lg font-semibold">About Us</h2>
          <p className="text-brand-text-light">
            bricksnmix is transforming online shopping into an experience and
            aims to enrich your shopping list wisely. With a wide range of
            products powered by fast delivery and 24/7 customer service, we
            enhance seamless shopping.
          </p>
        </div>
        <div className="md:w-1/2">
          <h2 className="text-lg font-semibold">24/7 Customer Support</h2>
          <p className="text-brand-text-light">
            The bricksnmix support team is hard-working 24/7 for our customers.
            We give high priority to troubleshooting and resolving all
            complaints and issues of our customers. We will provide complete
            support until your face smiles.
          </p>
        </div>
      </div>

      {/* Seller and Social Connections Section */}
      <div className="mb-4 flex flex-col items-center md:flex-row md:justify-between">
        <div className="mb-4 md:mb-0 md:w-1/2">
          <h2 className="text-lg font-semibold">Become a Seller</h2>
          <div className="flex flex-row gap-2">
            <NavLink
              to="/seller/register"
              className="rounded-lg bg-brand-light-gray px-4 py-2 font-semibold text-brand-primary hover:bg-brand-primary hover:text-white"
            >
              Register as Seller
            </NavLink>
            <NavLink
              to="/seller/login/email"
              className="rounded-lg bg-brand-light-gray px-4 py-2 font-semibold text-brand-primary hover:bg-brand-primary hover:text-white"
            >
              Login as Seller
            </NavLink>
          </div>
        </div>
        {/* <div className="ml-4">
                    <h2 className="text-lg font-semibold">Connect with Us</h2>
                    <div className="flex space-x-2">
                        <NavLink to="/youtube" className="flex items-center" aria-label="Follow us on YouTube">
                            <TfiYoutube className="text-brand-text-light  hover:text-brand-primary" size={24} />
                        </NavLink>
                        <NavLink to="/facebook" className="flex items-center " aria-label="Follow us on Facebook">
                            <AiOutlineFacebook className="text-brand-text-light hover:text-brand-primary" size={24} />
                        </NavLink>
                        <NavLink to="/instagram" className="flex items-center" aria-label="Follow us on Instagram">
                            <CiInstagram className="text-brand-text-light hover:text-brand-primary" size={24} />
                        </NavLink>
                        <NavLink to="/twitter" className="flex items-center" aria-label="Follow us on Twitter">
                            <FaSquareTwitter className="text-brand-text-light hover:text-brand-primary" size={24} />
                        </NavLink>
                    </div>
                </div> */}
        <div className="ml-4 space-y-2 md:w-1/2">
          <h2 className="text-lg font-semibold">Connect With Bricksnmix</h2>
          <p className="text-brand-text-light">
            Have questions, need assistance, or want to partner with us?
            Bricksnmix is here to help! Whether you're placing an order,
            exploring seller opportunities, or looking for expert product
            guidance, our team is just a message or call away.
          </p>
          <p className="flex items-center gap-2 text-brand-text-light">
            <MdOutlineLocalPhone size={22} /> 8594005250
          </p>
          <p className="flex items-center gap-2 text-brand-text-light">
            <AiOutlineMail size={22} />
            <a
              href="https://mail.google.com/mail/?view=cm&to=bricksnmix@gmail.com&."
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              bricksnmix@gmail.com
            </a>
          </p>
          <div className="flex space-x-2">
            <a
              href="https://youtube.com/@bricksnmixecommerce?si=VfjxNrVzp5d1SstM"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on YouTube"
            >
              <TfiYoutube
                className="text-brand-text-light hover:text-brand-primary"
                size={24}
              />
            </a>

            <a
             href="https://www.facebook.com/share/1CbwLeJDRZ/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Facebook"
            >
              <AiOutlineFacebook
                className="text-brand-text-light hover:text-brand-primary"
                size={24}
              />
            </a>

            <a
              href="https://www.instagram.com/bricksnmix"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Instagram"
            >
              <CiInstagram
                className="text-brand-text-light hover:text-brand-primary"
                size={24}
              />
            </a>

            <a
              href="https://twitter.com/Bricksnmix"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow us on Twitter"
            >
              <FaSquareTwitter
                className="text-brand-text-light hover:text-brand-primary"
                size={24}
              />
            </a>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="mt-6 text-center">
        <p className="text-xs text-brand-text-light">
          Copyright 2024 bricksnmix.com. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
